import AuthenticatedController from './AuthenticatedController';
import { API_KEY, API_KEYS } from '@mm/api-routes';
import { ApiKeyModel } from '../model/ApiKeyModel';

export default class ApiKeysController extends AuthenticatedController {
  static async getById(facebookPageId: number, apiKeyId: number) {
    return super.get(API_KEY(facebookPageId, apiKeyId));
  }

  static async getAll(facebookPageId: number) {
    return super.get(`${API_KEYS(facebookPageId)}?with_inactive=true`);
  }

  static async postApiKey(
    facebookPageId: number,
    ApiKey,
  ): Promise<ApiKeyModel> {
    const response = await super.post(API_KEYS(facebookPageId), ApiKey);
    return response.apiKey;
  }

  static async deleteApiKey(facebookPageId: number, apiKeyId: number) {
    return super.delete(API_KEY(facebookPageId, apiKeyId));
  }
  static async putApiKey(
    facebookPageId: number,
    apiKey: ApiKeyModel,
  ): Promise<ApiKeyModel> {
    return super.put(API_KEY(facebookPageId, apiKey.id), apiKey);
  }
}
